import { useState, useRef } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  MdOutlineGridView,
  MdFileUpload,
  MdDownload,
  MdStorefront,
  MdDescription,
  MdManageAccounts,
} from "react-icons/md";
import { FaSitemap } from "react-icons/fa";
import { Link } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { RiArrowLeftSFill } from "react-icons/ri";
import useCustomNavigate from "../Hook/useCustomNavigate";

const Mainmenu = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Track which menu items have active submenus

  // Position submenus correctly

  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeSubSubmenu, setActiveSubSubmenu] = useState(null);

  const [submenuTop, setSubmenuTop] = useState(0);

  // Refs for menu items to calculate positions
  const menuRefs = useRef([]);

  // Timeout for delayed menu closing
  const [closeTimeout, setCloseTimeout] = useState(null);

  // Toggle main dropdown
  const toggle = () => setDropdownOpen(!dropdownOpen);

  // Handle mouse entering a menu item
  const handleMouseEnter = (index) => {
    // Cancel any pending close operations
    cancelClose();

    // Calculate position for submenu
    const parentMenu = menuRefs.current[index];
    if (parentMenu) {
      setSubmenuTop(parentMenu.offsetHeight);
      setActiveSubmenu(index);
      setActiveSubSubmenu(null); // Reset sub-submenu when changing main menu
    }
  };

  // Handle mouse leaving menu with delay
  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      // setActiveSubmenu(null);
      setActiveSubSubmenu(null);
    }, 300); // 300ms delay before closing
    setCloseTimeout(timeout);
  };

  // Cancel pending menu close
  const cancelClose = () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      setCloseTimeout(null);
    }
  };

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className="user-dropdown"
      style={{ border: "none" }}
    >
      {/* Dropdown toggle button */}
      <DropdownToggle
        caret
        className="btn no-active btn-primary"
        style={{ border: "none" }}
      >
        <p className="hamburggericon">
          <MdOutlineGridView size={20} />
        </p>
      </DropdownToggle>

      {/* Main dropdown menu */}
      <DropdownMenu end onMouseLeave={handleMouseLeave}>
        {menuItems.map((menu, index) => (
          <DropdownItem
            key={index}
            className={`position-relative ${
              activeSubmenu === index ? "active-menu-item" : ""
            }`}
            onMouseEnter={() => handleMouseEnter(index)}
            ref={(el) => (menuRefs.current[index] = el)}
          >
            {/* Menu item content */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {menu.icon}
                <span
                  className="colorno1"
                  style={{
                    // color: "#270b79",
                    fontSize: "13px",
                    marginLeft: "8px",
                  }}
                >
                  {menu.label}
                </span>
              </div>

              {/* Show arrow if item has submenu */}
              {menu.items &&
                menu.items.length > 0 &&
                (activeSubmenu === index ? (
                  <span
                    className="d-flex align-items-center"
                    style={{
                      position: "relative",
                      left: "29px",
                      height: "20px",
                    }}
                  >
                    <RiArrowLeftSFill size={24} />
                  </span>
                ) : (
                  <MdKeyboardArrowDown size={16} color="#4b002b" />
                ))}
            </div>

            {/* Render submenu if this item is active */}
            {activeSubmenu === index && (
              <Submenu
                items={menu.items}
                top={index === 0 || index === 1 ? 0 : submenuTop}
                onMouseLeave={handleMouseLeave}
                onSubmenuHover={(subIndex) => setActiveSubSubmenu(subIndex)}
                onSubmenuMouseEnter={cancelClose}
                activeSubSubmenu={activeSubSubmenu}
                parentIndex={index}
              />
            )}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

const Submenu = ({
  items,
  top,
  onMouseLeave,
  onSubmenuHover,
  activeSubSubmenu,
  parentIndex,
  onSubmenuMouseEnter,
}) => {
  const navigate = useCustomNavigate();
  return (
    <div
      className="submenu"
      style={{
        position: "absolute",
        left: "100%",
        top: `0px`,
        backgroundColor: "white",
        border: "1px solid #ccc",
        zIndex: 1000,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        minWidth: "210px",
      }}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onSubmenuMouseEnter}
    >
      {items.map((item, index) => (
        <div
          key={index}
          onMouseEnter={() => onSubmenuHover(index)}
          className={`position-relative ${
            activeSubSubmenu === index ? "active-menu-item" : ""
          }`}
        >
          <div
            to={item.link}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <DropdownItem
              tag="div"
              className={`${
                activeSubSubmenu === index ? "active-menu-item bgcolor" : ""
              }`}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
                onClick={() => item.link && navigate(item.link)}
              >
                <div
                  className="colorno1"
                  style={{
                    // color: "#270b79",
                    fontSize: "13px",
                    marginLeft: "8px",
                  }}
                >
                  {" "}
                  {item.label}
                </div>
                {/* Show arrow if item has submenu */}
                {item.subItems &&
                  item.subItems.length > 0 &&
                  (activeSubSubmenu === index ? (
                    <span
                      className="d-flex align-items-center"
                      style={{
                        position: "relative",
                        left: "36px",
                        height: "20px",
                      }}
                    >
                      <RiArrowLeftSFill size={24} />
                    </span>
                  ) : (
                    <MdKeyboardArrowDown size={16} />
                  ))}
              </div>
            </DropdownItem>
          </div>

          {/* Render sub-submenu if this item is active */}
          {activeSubSubmenu === index &&
            item.subItems &&
            item.subItems.length > 0 && (
              <SubSubmenu items={item.subItems} parentSubIndex={index} />
            )}
        </div>
      ))}
    </div>
  );
};

const SubSubmenu = ({ items, parentSubIndex }) => {
  return (
    <div
      className="sub-submenu"
      style={{
        position: "absolute",
        left: "100%",
        top: "0",
        backgroundColor: "white",
        border: "1px solid #ccc",
        zIndex: 1001,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        minWidth: "210px",
      }}
    >
      {items.map((subItem, index) => (
        <Link
          key={index}
          to={subItem.link}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <DropdownItem className="hover-menu-item">
            {subItem.label}
          </DropdownItem>
        </Link>
      ))}
    </div>
  );
};

const menuItems = [
  {
    icon: <FaSitemap className="desginicon" />,
    label: "Master",
    items: [
      {
        label: "Company",
        link: "/master/company/company-list",
      },
      {
        label: "Warehouse ",
        link: "/master/warehouse-list",
        subItems: [
          { label: "Warehouse", link: "/master/warehouse-list"},
          // { label: "Zone", link: "/master/zone-list" },
          { label: "Bin ", link: "/master/bin-list"  },
        ]
      },
      {
        label: "Item ",
        link: "/master/item/item-list",
         subItems: [
          { label: "Item", link: "/master/item/item-list-new"},
          {
            label: "Group Item ",
            link: "/master/itemgroup/item-group-list",
          },
          {
            label: "Brand  ",
            link: "/master/brand/brand-list",
          },
          {
            label: "Item Attribute",
            link: "/master/item-attribute/item-attribute-list",
          },
          {
            label: "Item Price",
            link: "/master/item-price/item-price-list",
          },
          {
            label: "UOM",
            link: "/master/uom/uom-list",
          },
          {
            label: "SerialNo",
            link: "/master/serialno/serialno-list",
          },
        ],
      },
      {
        label: "Supplier",
        link: "/master/supplier/supplier-list",
        subItems: [
          {  label: "Supplier", link: "/master/supplier/supplier-list"},
          { label: "Supplier Group", link: "/master/suppliergroup/supplier-list" },
          { label: "Contact", link: "/master/contact-list"  },
        ]
      },
      {
        label: "Customer ",
        link: "/master/customer/customer-list",
        subItems: [
          { label: "Customer ", link: "/master/customer/customer-list"},
          { label: "Address ", link: "/master/address/address-list" },
          { label: "Contact", link: "/master/contact-list"  },
        ]
      },
      {
        label: "Tax",
        link: "/master/tax/tax-list",
         subItems: [
          {label: "Sales Taxes and Charges Template", link: "/master/tax/tax-list",},
          {label: "Purchase Taxes and Charges Template",link: "/master/tax/purchase-tax-list"},
          {label: "Item Tax Template ", link: "/master/itemtax/item-tax-list" },
          {label: "GST HSN Code ", link: "/master/gsthsncode/gst-hsn-list",  },
        ]
      },
      {
        label: "Payment Term",
        link: "/master/payment-term/payment-term-list",
         subItems: [
          { label: "Payment Term", link: "/master/payment-term/payment-term-list",},
          { label: "Payment Term Template", link: "/master/payment-term-template/payment-term-template-list" },
        ]
      },
      {
        label: "New Menu",
        link: "",
         subItems: [
          { label: "Melting Request ", link: "/melting/melting-request-list" },
          { label: "Old Gold Entry", link: "/oldgold/old-gold-entry-list" },
          { label: "Create Invoice", link: "/master/Invoice-Creation/Create-opening-invoice-Creation-Tool/CreateInvoiceCreation" },
          { label: "Period Closing Voucher", link: "/Master/Voucher/PeriodClosingVoucher/Period-Closing-Voucher-List" },
          { label: "Currency Exchange Details", link: "/master/currency-exchange-details/currency-exchange-details-list" },
          { label: "Quality Goal", link: "/master/quality-goal/quality-goal-list" },
          { label: "Quality Review", link: "/master/quality-review/quality-review-list" },
          { label: "Quality Action", link: "/master/quality-action/quality-action-list" },
          { label: "Quality Inspection", link: "/master/quality-inspection/main-list" },
          { label: "Quality Procedure", link: "/master/quality-procedure/quality-procedure-list" },
          { label: "Budget ", link: "/master/budget/budget-list" },
          { label: "Accounting Dimension Details ", link: "/master/add/add-list" },
          { label: "Exchange Rate Revaluation", link: "/Master/ExchangeRateRevaluation/mainList/ExchagereteRevalutionhead" },
          { label: "Cost Center Allocation", link: "/Master/CostCenterAllocation/CostCenterAllocationList/CostCenterAllocationList" },
          { label: "Journal Entry", link: "/Master/JournalEntry/main-list/JournalEntry" },
          { label: "Journal Entry Template", link: "/Master/JournalEntryTemplate/main-list/JournalEntryTemplateList" },
          { label: "Payment Entry", link: "/Master/PaymentEntry/Main-List/PaymentEntryList" },
          { label: "Customer Entry Form", link: "/Master/CustomerEntryForm/Main-List/CustomerEntryFormList" },
          { label: "Customer Data and Feedback Form", link: "/master/customerdatafeedback/main-list/customerdataandfeedbackformlist" },
          { label: "Product View ", link: "/master/productview/main-list/productviewlist" },
          { label: "Bank Account", link: "/master/bank-account/bank-account-list" },
          { label: "Bank Clearance", link: "/master/bank-clearance/bank-clearance-list" },


        ]
      },


    ],
  },
  {
    icon: <MdFileUpload className="desginicon" />,
    label: "Inbound",
    items: [
      {
        label: "Dashboard",
        link: "/inbound/dashboard",
      },
      {
        label: "Gate In",
        link: "/inbound/gate-entry/gate-entry-list",
      },
      {
        label: "Purchase Order",
        link: "/inbound/purchaseorder/purchase-orders",
      },
      {
        label: "ASN",
        link: "/inbound/asn/inboundasn",
      },

      {
        label: "GRN",
        link: "/inbound/grn/create-grn-receipt",
      },

      {
        label: " Put-away",
        link: "/inbound/putaway/create-in-putaway",
      },
      {
        label: "Return",
        link: "/inbound-return/purchaseorder/create-purchase-return-bulk",
        subItems: [
          {
            label: "Purchase Bulk ",
            link: "/inbound-return/purchaseorder/create-purchase-return-bulk",
          },

          // { label: "Stock ", link: "/report/stock-ledger" },
        ],
      },
    ],
  },
  {
    icon: <MdDownload className="desginicon" />,
    label: "Outbound",
    items: [
      {
        label: "Dashboard",
        link: "/outbound/dashboard",
      },
      {
        label: "Sales Order",
        link: "/outbound/outbound-sales-order",
      },
      {
        label: "Pick List",
        link: "/outbound/pick/outboundpick",
      },
      {
        label: "Delivery Note",
        link: "/outbound/outbound-delivery-note",
      },
      {
        label: "Sales Invoice",
        link: "/outbound/outbound/sales-invoice",
      },

      {
        label: "Packing Slip",
        link: "/outbound/outbound-packingslip",
      },
      {
        label: "Gate Out",
        link: "/outbound/shippinglist",
      },
    ],
  },
  {
    icon: <MdStorefront className="desginicon" />,
    label: "Warehouse",
    items: [
      {
        label: "BOM ",
        link: "/assmbly/bom-list/",
      },
      {
        label: "Work Order",
        link: "/assmbly/assembly-list",
      },
      {
        label: "Pick List ",
        link: "/assmbly/pick-list",
      },
    ],
  },
  {
    icon: <MdDescription className="desginicon" />,
    label: "Report",
    items: [
      {
        label: "Ledger",
        link: "/dashboard/",
        subItems: [
          { label: "Warehouse ", link: "/report/warehouse-ledger" },

          { label: "Stock ", link: "/report/stock-ledger" },
        ],
      },
      {
        label: "Purchase Report",
        link: "/dashboard/",
        subItems: [
          { label: "Purchase Analytics ", link: "/report/purchase-analytics" },
          {
            label: "Purchase Order Analysis",
            link: "/report/purchase-order-analytics",
          },
          {
            label: "Supplier Wise Sales Analytics",
            link: "/report/supplier-wise-sales-analytics",
          },
          {
            label: "Items to Order and Receive",
            link: "/report/items-to-order-and-receive",
          },
          {
            label: "Purchase Order Trends",
            link: "/report/purchase-order-trends",
          },
          {
            label: "Item-wise Purchase History ",
            link: "/report/item-wise-purchase-history",
          },
        ],
      },
      {
        label: "Sales Report",
        link: "/dashboard/",
        subItems: [
          { label: "Sales Analytics ", link: "/report/sales-analytics-report" },
          {
            label: "Sales Order Analysis ",
            link: "/report/sales-order-analytics",
          },
          {
            label: "Item-wise Sales History ",
            link: "/report/item-wise-sales-history",
          },
        ],
      },
      {
        label: "Warehouse",
        link: "/dashboard/",
        subItems: [
          { label: "Stock Analytics ", link: "/report/stock-analytics" },
          {
            label: "Delivery Note Trends",
            link: "/report/delivery-note-trends",
          },
          {
            label: "Purchase Receipt Trends",
            link: "/report/purchase-receipt-trends",
          },
          {
            label: "Batch-Wise Balance History",
            link: "/report/batch-wise-balance-history",
          },

          { label: "Work Order Summary", link: "/report/work-order-summary" },
          { label: "Job Card Summary ", link: "/report/job-card-summary" },
          { label: "BOM Stock ", link: "/report/bom-stock-report" },
          {
            label: "Work Order Consumed Materials ",
            link: "/report/work-order-consumed-materials",
          },
        ],
      },
    ],
  },
  {
    icon: <MdManageAccounts className="desginicon" />,
    label: "User Management",
    link: "/manage-users",
    items: [
      { label: "Login Track", link: "/usermanage/login-track" },

      { label: "Users", link: "/usermanage/manage-users" },
      { label: "Role & Permission", link: "/manage-users/Roles" },
      { label: "Logged In Users", link: "/manage-users/Login-Users" },
      { label: "Activity Logs", link: "/manage-users/Activity-Log" },
    ],
  },
];

export default Mainmenu;
